/** Driver 表示階層指定 id */
export const DRIVER_PORTAL_ROOT_CLASS = 'driver-portal-root';
/** オーバーレイ表示時の フェードアニメーション時間 (ms) */
export const ANIMATION_TIME_FADE = 500;
/** 次要素への移動 アニメーション時間 (ms) */
export const ANIMATION_TIME_MOVING = 500;
